import React, { useState, useEffect } from 'react';
import Login from './components/Login.jsx';
import Chat from './components/Chat.jsx';

export default function App() {
  const [session, setSession] = useState(null);

  useEffect(() => {
    const token = sessionStorage.getItem('idToken');
    const email = sessionStorage.getItem('userEmail');
    if (token && email) setSession({ token, email });
  }, []);

  const handleLogin = (email, token) => {
    sessionStorage.setItem('idToken', token);
    sessionStorage.setItem('userEmail', email);
    setSession({ token, email });
  };

  const handleLogout = () => {
    sessionStorage.clear();
    setSession(null);
  };

  return session
    ? <Chat session={session} onLogout={handleLogout} />
    : <Login onLogin={handleLogin} />;
}
